"use strict";

// Source code adapted from: https://github.com/scsenge/pull-to-refresh
angular
.module('core')
.directive('pullToRefresh', function($state, IS_MOBILE_APP) {
    return {
        templateUrl: require('./pull-to-refresh.directive.html'),
        transclude: true,
        link: function(scope, element) {
            scope.IS_MOBILE_APP = IS_MOBILE_APP;
            scope.requiredPercentage = 0.30;
            if (scope.IS_MOBILE_APP) {
                element.bind("touchend", onTouchEnd);
                element.bind("touchmove", onTouchMove);
                element.bind("touchstart", onTouchStart);
            }

            function onTouchMove(event) {
                var windowHeight = window.innerHeight;
                this.currentMousePosition = event.originalEvent.touches[0].clientY;
                if (!this.reachedTheTop) {
                    var allowUp = (window.pageYOffset > 1);
                    var up = (event.originalEvent.touches[0].pageY > this.slideBeginY);
                    var down = (event.originalEvent.touches[0].pageY < this.slideBeginY);
                    this.slideBeginY = event.originalEvent.touches[0].pageY;
                    if ((up && !allowUp) && !down) {
                        this.reachedTheTop = true;
                        this.refreshStartPosition = this.currentMousePosition;
                    }
                }
                else {
                    progressBarUpdate(this.refreshStartPosition, this.currentMousePosition, windowHeight);
                }
            }

            function onTouchEnd(e) {
                if (this.reachedTheTop) {
                    this.reachedTheTop = false;
                    if (isRefreshNeeded(this.currentMousePosition, this.refreshStartPosition)) {
                        progressBarToRefreshPosition();
                        $state.reload().then(function() {
                            progressBarRestore();
                        });
                    }
                    else {
                        progressBarRestore();
                    }
                }
            }

            function onTouchStart(event) {
                this.slideBeginY = event.originalEvent.touches[0].pageY;
            }

            function isRefreshNeeded(currentMousePosition, refreshStartPosition) {
                var w = window.innerHeight;
                return (currentMousePosition - refreshStartPosition) > w * scope.requiredPercentage;
            }

            function getPercentage(refreshStartPosition, currentMousePosition, w) {
                return Math.max(Math.min((currentMousePosition - refreshStartPosition) / (w * scope.requiredPercentage) * 100, 100), 0);
            }

            function rotate(element, degree) {
                element[0].style.transform = 'rotate(' + degree + 'deg)';
                element[0].style.webkitTransform = 'rotate(' + degree + 'deg)';
                element[0].style.MozTransform = 'rotate(' + degree + 'deg)';
                element[0].style.msTransform = 'rotate(' + degree + 'deg)';
                element[0].style.OTransform = 'rotate(' + degree + 'deg)';
            }

            function progressBarRestore() {
                setProgressBarPosition(0);
                setProgressBarColorAndOpacity(0);
                setProgressAngle(0);
            }

            function progressBarToRefreshPosition() {
                var refreshingPlace = -40 + window.innerHeight * scope.requiredPercentage;
                setProgressBarPosition(refreshingPlace);
            }

            function setProgressBarPosition(pulledDown) {
                var pbelement = document.getElementsByClassName("progress-bar-container");
                //progress-bar-position
                var translation = Math.min(pulledDown, window.innerHeight * scope.requiredPercentage) + Math.max(pulledDown - window.innerHeight * scope.requiredPercentage, 0) * 0.1;
                pbelement[0].style.transform = 'translate(0px,' + translation + 'px)';
                pbelement[0].style.webkitTransform = 'translate(0px,' + translation + 'px)';
                pbelement[0].style.MozTransform = 'translate(0px,' + translation + 'px)';
                pbelement[0].style.msTransform = 'translate(0px,' + translation + 'px)';
                pbelement[0].style.OTransform = 'translate(0px,' + translation + 'px)';
            }

            function setProgressBarColorAndOpacity(percentage) {
                document.getElementsByClassName("progress-bar-container")[0].style.opacity = (percentage * 2) / 100;
                document.getElementsByClassName("reloadicon")[0].style.opacity = percentage / 100;
            }

            function setProgressAngle(percentage) {
                // calculate the angle
                var drawAngle = percentage / 100 * 360;
                var firstHalfAngle;
                var secondHalfAngle;

                // calculate the angle to be displayed if each half
                if (drawAngle <= 180) {
                    firstHalfAngle = drawAngle;
                    secondHalfAngle = 0;
                }
                else {
                    firstHalfAngle = 180;
                    secondHalfAngle = drawAngle - 180;
                }
                //loading bar percentage angle
                rotate(document.getElementsByClassName("slice1"), firstHalfAngle);
                rotate(document.getElementsByClassName("slice2"), secondHalfAngle);
            }

            function progressBarUpdate(refreshStartPosition, currentMousePosition, w) {
                var pulledDown = currentMousePosition - refreshStartPosition;
                var percentage = getPercentage(refreshStartPosition, currentMousePosition, w);
                // set the transitions:
                setProgressBarPosition(pulledDown);
                setProgressBarColorAndOpacity(percentage);
                setProgressAngle(percentage);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/pull-to-refresh/pull-to-refresh.directive.js
// module id = 884
// module chunks = 0